module.exports = __webpack_public_path__ + "static/media/Hooman Shayani.c92d8547.png";